import { render, staticRenderFns } from "./ArchiveClip.vue?vue&type=template&id=449a45ac&scoped=true"
import script from "./ArchiveClip.vue?vue&type=script&lang=js"
export * from "./ArchiveClip.vue?vue&type=script&lang=js"
import style0 from "./ArchiveClip.vue?vue&type=style&index=0&id=449a45ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a45ac",
  null
  
)

export default component.exports